<template>
  <div class="addConGoods">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="width: 100%;height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="rigth" label-width="100px"
        :rules="addFormRule" ref="addForm">
        <el-form-item label="商品标识" prop="goodsName">
          <el-input v-model="addForm.goodsName" disabled style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="客户可销">
          <el-button type="primary" style="margin-left:5px" @click="selData('unitY')">选择客户</el-button>
          <div style="margin-top: 10px;margin-left: 5px;" v-show="addForm.unitY.length">
            <el-tag
              v-for="(item,index) in addForm.unitY"
              :key="index"
              closable
              @close="tagClose('unitY',index)"
              type="success"
              effect="dark"
              :disable-transitions="false"
              class="my-el-tag">
              {{item.label}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="客户禁销">
          <el-button type="primary" style="margin-left:5px" @click="selData('unitN')">选择客户</el-button>
          <div style="margin-top: 10px;margin-left: 5px;" v-show="addForm.unitN.length">
            <el-tag
              v-for="(item,index) in addForm.unitN"
              :key="index"
              closable
              @close="tagClose('unitN',index)"
              type="danger"
              effect="dark"
              :disable-transitions="false"
              class="my-el-tag">
              {{item.label}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="区域可销">
          <el-button type="primary" style="margin-left:5px" @click="selData('areaY')">选择区域</el-button>
          <div style="margin-top: 10px;margin-left: 5px;" v-show="addForm.areaY.length">
            <el-tag
              v-for="(item,index) in addForm.areaY"
              :key="index"
              closable
              @close="tagClose('areaY',index)"
              type="success"
              effect="dark"
              :disable-transitions="false"
              class="my-el-tag">
              {{item.label}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="区域禁销">
          <el-button type="primary" style="margin-left:5px" @click="selData('areaN')">选择区域</el-button>
          <div style="margin-top: 10px;margin-left: 5px;" v-show="addForm.areaN.length">
            <el-tag
              v-for="(item,index) in addForm.areaN"
              :key="index"
              closable
              @close="tagClose('areaN',index)"
              type="danger"
              effect="dark"
              :disable-transitions="false"
              class="my-el-tag">
              {{item.label}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="类型可销">
          <el-button type="primary" style="margin-left:5px" @click="selData('typeY')">选择类型</el-button>
          <div style="margin-top: 10px;margin-left: 5px;" v-show="addForm.typeY.length">
            <el-tag
              v-for="(item,index) in addForm.typeY"
              :key="index"
              closable
              @close="tagClose('typeY',index)"
              type="success"
              effect="dark"
              :disable-transitions="false"
              class="my-el-tag">
              {{item.label}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="类型禁销">
          <el-button type="primary" style="margin-left:5px" @click="selData('typeN')">选择类型</el-button>
          <div style="margin-top: 10px;margin-left: 5px;" v-show="addForm.typeN.length">
            <el-tag
              v-for="(item,index) in addForm.typeN"
              :key="index"
              closable
              @close="tagClose('typeN',index)"
              type="danger"
              effect="dark"
              :disable-transitions="false"
              class="my-el-tag">
              {{item.label}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-button type="primary" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </el-scrollbar>

    <!-- 数据选择弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
      style="margin: auto;">
      <search-bar>
        <template>
          <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入编号/名称" v-model="dialogSearch.name"></el-input>
          <el-button type="primary" icon="el-icon-search" @click="getTableData">搜索</el-button>
          <el-button type="primary" icon="el-icon-circle-check" @click="selDataOk">确定</el-button>
        </template>
      </search-bar>
      <el-table
        :data="tableData"
        stripe border
        @row-dblclick="rowClick"
        @selection-change="selectionChange"
        tooltip-effect="dark"
        style="width: 100%;">
        <el-table-column
          label="序号"
          align="center"
          width="50">
          <template slot-scope="scope">
            <span>{{(dialogCurrPage - 1) * dialogPageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          type="selection"
          align="center"
          width="55">
        </el-table-column>
        <el-table-column
          v-for="(value,key) in tableHead"
          align="center"
          :key="key"
          show-overflow-tooltip
          :label="value">
          <template slot-scope="scope">
            <span>{{scope.row[key]}}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @hanCurrChange="dialogCurrChange"
        :currIndex="dialogCurrPage"
        :pageSize="dialogPageSize"
        layout="total, prev, pager, next, jumper"
        :allPage="dialogAllPage">
      </pagination>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'addConGoods',
  data() {
    return {
      goodsId: '',
      /**新增表单 */
      addForm:{
        goodsId:"", // 商品ID
        goodsName: '', // 商品名称
        unitY: [], // 客户可销
        unitN: [], // 客户禁销
        areaY: [], // 区域可销
        areaN: [], // 区域禁销
        typeY: [], // 类型可销
        typeN: [], // 类型禁销
      },
      /**新增表单规则 */
      addFormRule:{
        goodsName: [mustFill],
      },
      tableData: [],
      tableHead: {},
      dialogVisible:false,
      dialogTitle: '',
      dialogSearch: {
        name: '',
        label: '',
        type: '',
        sqlType: ''
      },
      dialogCurrPage: 1,
      dialogPageSize: 10,
      dialogAllPage: 0,
      // 存放选中的表格数据
      selectedList: [],
      // 表格多选时是否有已选的数据
      isSelDataOkRep: false
    }
  },
  components: {
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if (prams) {
      //执行编辑
      this.goodsId = prams.goodsId;
      this.getControlInfo();
    }
  },
  methods:{
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    getControlInfo(){
      let data = {
        type: "GetById",
        id: this.goodsId
      };
      let proc = "Proc_Admin_GoodsList";//存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
        method:"post",
      }).then((res) => {
        console.log(res);
        if (res.flag == 0) {
          this.addForm.goodsId = res.table0[0].article_id
          this.addForm.goodsName = res.table0[0].sub_title
          let list = res.table1 || []
          list.forEach(item => {
            if(item.lx == 1){
              this.addForm.unitY.push({
                label: item.dwmch,
                value: item.dwbh
              })
            }else{
              this.addForm.unitN.push({
                label: item.dwmch,
                value: item.dwbh
              })
            }
          })
          this.addForm.areaY =  this.changeArr(res.table0[0].bkxquyufl,res.table0[0].bkxquyuflmc)
          this.addForm.areaN =  this.changeArr(res.table0[0].kxquyufl,res.table0[0].kxquyuflmc)
          this.addForm.typeY =  this.changeArr(res.table0[0].bkxkehufl,res.table0[0].bkxkehuflmc)
          this.addForm.typeN =  this.changeArr(res.table0[0].kxkehufl,res.table0[0].kxkehuflmc)
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err)=>{
        console.log(err);
      })
    },
    //数组转化
    changeArr(value,label){
      let list = []
      if(value && label){
        if(value[value.length - 1] == ','){
          value = value.substr(0,value.length - 1)
        }
        if(label[label.length - 1] == ','){
          label = label.substr(0,label.length - 1)
        }
        value = value.split(',')
        label = label.split(',')
        for(let i = 0; i < value.length; i++){
          list.push({
            label: label[i],
            value: value[i],
          })
        }
      }
      return list
    },
    // 标签关闭
    tagClose(key,index){
      this.addForm[key].splice(index,1)
    },
    // 设置数据的属性
    selData(key){
      if(key == 'unitY' || key == 'unitN'){
        this.dialogTitle = '选择客户'
        this.dialogSearch.name = ''
        this.dialogSearch.label = 'unit'
        this.dialogSearch.sqlType = 'CompanyList'
      }else if(key == 'areaY' || key == 'areaN'){
        this.dialogTitle = '选择区域'
        this.dialogSearch.name = ''
        this.dialogSearch.label = 'area'
        this.dialogSearch.sqlType = 'RegionList'
      }else if(key == 'typeY' || key == 'typeN'){
        this.dialogTitle = '选择类型'
        this.dialogSearch.name = ''
        this.dialogSearch.label = 'type'
        this.dialogSearch.sqlType = 'TypeList'
      }
      this.dialogSearch.type = key
      this.getTableData()
    },
    // 获取数据
    getTableData(){
      let data = {
        type: this.dialogSearch.sqlType,
        strWhere: this.dialogSearch.name,
        pageIndex: this.dialogCurrPage,
        pageSize: this.dialogPageSize,
        spid: this.goodsId,
      };
      let type = 'ReturnDataSet'
      let proc = 'Proc_Admin_SearchInfo'
      this.$requestSys({
        url: "ashx/MainReturnJson.ashx?json=" + encodeURIComponent(JSON.stringify(data)) + "&type=" + encodeURIComponent(type) + "&proc=" + encodeURIComponent(proc),
        method: 'post'
      }).then(res => {
        this.dialogAllPage = res.recordCount
        this.tableData = []
        this.tableHead = {}
        if(res.flag == 0){
          this.tableData = res.content
          this.tableHead = res.fdname
          this.dialogVisible = true
        }else{
          this.$message({
            message: res.message || '获取数据失败',
            type: 'error'
          });
        }
      })
    },
    /**selection change触发事件 */
    selectionChange(section){
      //存放选中的表格数据
      this.selectedList = section;
    },
    // 数据单行双击选择
    rowClick(row,isSelDataOk){
      for(let i = 0; i < this.addForm[this.dialogSearch.label + 'Y'].length; i++){
        if(this.addForm[this.dialogSearch.label + 'Y'][i].value == row.keyid){
          if(isSelDataOk === true){
            this.isSelDataOkRep = true
          }else{
            this.$message({
              message: '选择的数据已在列表中',
              type: 'warning'
            });
          }
          return
        }
      }
      for(let i = 0; i < this.addForm[this.dialogSearch.label + 'N'].length; i++){
        if(this.addForm[this.dialogSearch.label + 'N'][i].value == row.keyid){
          if(isSelDataOk === true){
            this.isSelDataOkRep = true
          }else{
            this.$message({
              message: '选择的数据已在列表中',
              type: 'warning'
            });
          }
          return
        }
      }
      let label = ''
      if(this.dialogSearch.label == 'unit'){
        label = '单位名称'
      }else if(this.dialogSearch.label == 'area'){
        label = '地址'
      }else if(this.dialogSearch.label == 'type'){
        label = '客户类型'
      }
      this.addForm[this.dialogSearch.type].push({
        value: row.keyid,
        label: row[label]
      })
      this.dialogVisible = false
    },
    // 选择数据完成，多选
    selDataOk(){
      if(this.selectedList.length == 0){
        this.$message({
          message: '请选择数据',
          type: 'warning'
        });
        return
      }
      this.selectedList.forEach(item => {
        this.rowClick(item,true)
      })
      if(this.isSelDataOkRep){
        this.$message({
          message: '选择的数据已在列表中',
          type: 'warning'
        });
        this.isSelDataOkRep = false
      }
    },
    /**分页size改变 */
    hanSiChange(val){
      this.dialogPageSize = val;
      this.getTableData()
    },
    /**当前页改变 */
    dialogCurrChange(val){
      this.dialogCurrPage = val;
      this.getTableData()
    },

    /**提交表单 */
    submitForm(){
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          let data = {
            type: "IncreaseLimitpin",
            ableUnitCode: this.addForm.unitY.map(item => item.value).join(','),
            unableUnitCode: this.addForm.unitN.map(item => item.value).join(','),
            ableUnitName: this.addForm.unitY.map(item => item.label).join(','),
            unableUnitName: this.addForm.unitN.map(item => item.label).join(','),
            ableRegionCode: this.addForm.areaY.map(item => item.value).join(','),
            unableRegionCode: this.addForm.areaN.map(item => item.value).join(','),
            ableRegionName: this.addForm.areaY.map(item => item.label).join(','),
            unableRegionName: this.addForm.areaN.map(item => item.label).join(','),
            ableClassifyCode: this.addForm.typeY.map(item => item.value).join(','),
            unableClassifyCode: this.addForm.typeN.map(item => item.value).join(','),
            ableClassifyName: this.addForm.typeY.map(item => item.label).join(','),
            unableClassifyName: this.addForm.typeN.map(item => item.label).join(','),
            articleId: this.goodsId,
            id: this.goodsId
          };
          let proc = "Proc_Admin_RegionControlPin";//存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
            method:"post",
          }).then((res) => {
            if(res.flag == 0){
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.goBack()
            }else{
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err);
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.addConGoods{
  width: 100%;
  height: 100%;
}
</style>
